const viewBodyContentTpl = (resourceType, viewBodyContentData) => {
  let html = "";
  const { columns } = viewBodyContentData;
  let bodyContentBackgroundDivLength = columns.length;

  switch (resourceType) {
    case "date":
      html += `<div class="projects-calendar__body-content-background">${(function () {
        let html = ``;

        for (let i = 0; i < bodyContentBackgroundDivLength; i++) {
          html += `<div style="flex: 0 0 calc(100% / ${bodyContentBackgroundDivLength});"></div>`;
        }

        return html;
      })()}</div>`;

      break;

    case "area":
      html += `<div class="projects-calendar__body-content-background">${(function () {
        let html = ``;

        for (let i = 0; i < bodyContentBackgroundDivLength; i++) {
          html += `<div style="flex: 0 0 calc(100% / ${bodyContentBackgroundDivLength});"></div>`;
        }

        return html;
      })()}</div>`;

      break;

    default:
      break;
  }

  return html;
};

export { viewBodyContentTpl };
